module.exports = __webpack_public_path__ + "static/media/nodeStruct2.b048d62e.png";